import { cn } from '#/lib/utils';
import { Check } from '#/components/Check';

const CheckmarkIcon = () => (
  <span className="flex size-24 shrink-0 items-center justify-center rounded-full bg-cipher">
    <Check className="h-8 w-12 text-cloud" />
  </span>
);

const DashIcon = ({ isDark }: { isDark: boolean }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="shrink-0"
  >
    <path
      className={isDark ? 'stroke-grayscale-03' : 'stroke-grayscale-04'}
      d="M4.5 12H19.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CellIcon = ({
  icon,
  isDark,
  className,
}: {
  icon?: 'Checkmark' | 'Dash' | null;
  isDark: boolean;
  className?: string;
}) => {
  if (!icon) return null;

  return (
    <span className={cn('inline-flex', className)}>
      {icon === 'Checkmark' ? <CheckmarkIcon /> : <DashIcon isDark={isDark} />}
    </span>
  );
};
